import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/components/banner/banner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/components/blog-components/blogs-update/blogs-update.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/components/home-faqs/home-faqs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/components/medical-department/medical-department.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/scroll-reveal/scroll-reveal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/components/why-is-lucy/why-is-lucy.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/gradient.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/learnMore.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/light-gradient.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/play.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
